module.exports = __webpack_public_path__ + "static/img/合同章.2ace5a88.png";